<template>

    <div class="modale" :class="{ 'visible' : modalOpened }">
        <dialog class="dialog dialog--site">

            <div class="dialog__heading">

                <h3 class="dialog-title">Choisir un site de livraison</h3>

                <button class="dialog__heading__close" v-if="isSiteSelected"
                    type="button"
                    @click="hideSiteModal()">
                    <i class="fa fa-close"></i>
                </button>
            </div>

            <div class="dialog__body">
                <div class="woocommerce">

                    <form class="form" name="siteSelectionForm" :action="$config.SITE_URL" method="post">

                        <div class="form-row form-row-wide">
                            <label>Client</label>
                            <div class="filter">
                                <Select :options="clientOptions"
                                    v-model="selectedClientId"
                                    @change="selectedSiteCode = null"
                                    css="woocommerce-Input woocommerce-Input--text input-text"
                                    name="selected_client_id"
                                    placeholder="Choisir un compte client"
                                    autocomplete>
                                </Select>
                            </div>
                        </div>

                        <div class="form-row form-row-wide">
                            <label>Site de livraison</label>
                            <div class="filter">
                                <Select :options="siteOptions"
                                    :disabled="!selectedClientId"
                                    v-model="selectedSiteCode"
                                    css="woocommerce-Input woocommerce-Input--text input-text"
                                    name="selected_site_id"
                                    placeholder="Choisir un site"
                                    autocomplete>
                                </Select>
                            </div>

                        </div>

                        <div class="dialog__body__actions">

                            <button class="button alt"
                                type="submit"
                                name="validate"
                                value="validate"
                                :disabled="( !selectedSiteCode )">Sélectionner</button>
                            <button class="button"
                                type="button"
                                v-if="isSiteSelected"
                                @click="hideSiteModal()">Annuler</button>

                            <hr class="dialog-divider"
                                v-if="!isSiteSelected" />

                            <a class="link"
                                :href="$config.LOGOUT_URL"
                                v-if="!isSiteSelected">Se déconnecter</a>  

                        </div>                     
                    </form>

                </div>
            </div>

        </dialog>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex'

import { useLogin } from '@/helpers/auth'
import Select  from '@/components/select/Select.vue'
import { actions as clientActions } from '@/store/clients'
import { actions as siteActions } from '@/store/sites'
import { actions as utilisateurActions } from '@/store/utilisateurs'

export const SITE_EVENT = 'selectSite'

export const SiteBus = new Vue();

export let SITE_MODALE_OPENED = false;

export default {

    data() {
        return {
            ready: false,
            selectedClientId: null,
            selectedSiteCode: null,
            modalOpened: false
        }
    },

    computed: mapState({

        clients: state => state.clients.all,

        clientOptions: state => {
            if ( !state.clients.all ) return []
            return state.clients.all.map( client => {
                return {
                    name: client.label,
                    value: client.id
                }
            })
        },

        clientAddresses: function(state) {
            if ( this.selectedClientId == null ) return []            
            return state.utilisateurs.currentAddresses.filter( clientAddress => ( clientAddress.clientId === this.selectedClientId ) )
        },

        currentClient: state => state.clients.current,

        currentSite: state => state.sites.current,

        isAuth: state => ( state.utilisateurs.current !== null ),

        isSiteSelected: state => ( state.sites.current !== null ),

        markets: state => state.sites.markets,

        siteOptions: function() {

            if ( this.selectedClientId == null ) return []

            let siteOptions = []
            this.clientAddresses.forEach(clientAddress => {
                siteOptions.push({
                    value: clientAddress.site.id,
                    name: clientAddress.label
                })
            })

            siteOptions = siteOptions.concat(this.markets.map( market => {
                return {
                    name: market.label,
                    value: market.site.id
                }
            }))

            return siteOptions
        },

        utilisateur: state => state.utilisateurs.current

    }),

    methods: {

        resetValues: function() {
            if ( this.$store.state.sites.currentId != null ) {
                this.selectedClientId = this.$store.state.clients.currentId
                this.selectedSiteCode = this.$store.state.sites.currentId
            }
        },

        showSiteModal: function() {

            if ( SITE_MODALE_OPENED ) {
                return
            }

            this.resetValues()
            this.modalOpened = SITE_MODALE_OPENED = true
        },

        hideSiteModal: function() {
            this.modalOpened = SITE_MODALE_OPENED = false
        }
    },

    created() {

        const { isLogged, clientId, siteId } = useLogin()

        /// Si l'utilisateur n'est pas authentifié,
        /// On ne charge rien
        if ( !isLogged ) {
            return
        }

        /// Cas 1: Utilisateur authentitifié mais site de livraison pas encore sélectionné
        if ( clientId == null || siteId == null ) {
            Promise.all([
                this.$store.dispatch(clientActions.GET_ALL),
                this.$store.dispatch(siteActions.GET_MARKETS),
                this.$store.dispatch(utilisateurActions.GET),        
                this.$store.dispatch(utilisateurActions.GET_ADDRESSES)
                
            ])
            .then( () => {
                
                this.clients.forEach( client => {
                    if ( client.id == this.utilisateur.defaultClientId ) {
                        this.selectedClientId = client.id
                        client.clientAddresses.forEach( clientAddress => {
                            if ( clientAddress.id == this.utilisateur.defaultAddressId ) {

                                this.selectedSiteCode = clientAddress.site.id
                            }
                        })
                    }
                })

                this.ready = true
                this.showSiteModal()
            })     
            return   
        }
        
        /// Cas 2: authentifié et site de livraison choisi  
        Promise.all([
            this.$store.dispatch(clientActions.GET),
            this.$store.dispatch(clientActions.GET_ALL),
            this.$store.dispatch(siteActions.GET),
            this.$store.dispatch(siteActions.GET_ALL),
            this.$store.dispatch(siteActions.GET_MARKETS),
            this.$store.dispatch(utilisateurActions.GET),          
            this.$store.dispatch(utilisateurActions.GET_ADDRESSES)
            
        ])
        .then( () => {
            this.ready = true 
        })

        SiteBus.$on(SITE_EVENT, () => this.showSiteModal())
    },

    components: {
        Select
    },

    name: 'SiteModale'
}
</script>

<style>

#site {
    padding-right: 2.5rem;
}

.topbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    height: 2rem;
    background-color: rgb(255, 255, 255);
}

.topbar .topbar__menu {    
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
}

.topbar .topbar__menu .topbar__menu__item,
.topbar .topbar__menu .topbar__menu__item:hover,
.topbar .topbar__menu .topbar__menu__item:active {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    padding: 0 1.5rem;

    color: rgb(75, 75, 75);
    font-size: 85%;    
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
}

.topbar .topbar__menu .topbar__menu__item:hover {
    background-color: rgb(235, 235, 235);
}

.topbar .topbar__menu .topbar__menu__item > i {
    color: rgba(75, 75, 75, 0.7);
    margin-right: 0.5rem;
}

.topbar .topbar__menu .topbar__menu__item.topbar__menu__item--location .topbar-title {
    display: none;
}

@media screen and (min-width: 800px) {

    .dialog.dialog--site {
        min-width: 55rem;
    }
    
    .topbar .topbar__menu .topbar__menu__item.topbar__menu__item--location .topbar-title {
        display: inline;
    }
}

</style>
